import { toast, ToastOptions } from 'react-toastify';
import { Alert, TAlertData } from '../components/Common/Alert';

export const customToast = (
  data: TAlertData,
  type: ToastOptions<TAlertData>['type'] = 'success',
  options?: ToastOptions<TAlertData>,
) => {
  toast(Alert, {
    type,
    data,
    hideProgressBar: true,
    ...options,
  });
};
